<header class="header">
    <div class="container header-content">
        <a routerLink="/" class="logo">
            <span class="logo-icon">🌸</span>
            <span class="logo-text">GlassSkin<span class="highlight">Guide</span></span>
        </a>
    </div>
</header>